import React from 'react';
import { FileTextIcon, SendIcon, UsersIcon, PlusIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import StatCard from '../components/dashboard/StatCard';
import RecentNewsletterCard from '../components/dashboard/RecentNewsletterCard';
const Dashboard = () => {
  const recentNewsletters = [{
    id: '1',
    title: 'May Product Updates',
    template: 'Monthly Update',
    sentDate: 'May 15, 2023',
    recipients: 1250,
    status: 'sent'
  }, {
    id: '2',
    title: 'Special Offer: Summer Promotion',
    template: 'Promotional',
    sentDate: 'May 10, 2023',
    recipients: 850,
    status: 'sent'
  }, {
    id: '3',
    title: 'June Newsletter Draft',
    template: 'Monthly Update',
    sentDate: 'Scheduled for Jun 1, 2023',
    recipients: 1500,
    status: 'scheduled'
  }, {
    id: '4',
    title: 'Welcome Series: New Entrepreneurs',
    template: 'Welcome',
    sentDate: 'Not sent yet',
    recipients: 45,
    status: 'draft'
  }];
  return <div className="space-y-6" data-id="element-81">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-82">
        <h2 className="text-2xl font-bold text-secondary-900" data-id="element-83">Dashboard</h2>
        <div className="flex space-x-3 mt-3 sm:mt-0" data-id="element-84">
          <Link to="/templates/create" className="btn btn-outline flex items-center" data-id="element-85">
            <PlusIcon size={16} className="mr-1" data-id="element-86" />
            <span data-id="element-87">New Template</span>
          </Link>
          <Link to="/newsletters/create" className="btn btn-primary flex items-center" data-id="element-88">
            <PlusIcon size={16} className="mr-1" data-id="element-89" />
            <span data-id="element-90">New Newsletter</span>
          </Link>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-91">
        <StatCard title="Active Templates" value={12} icon={<FileTextIcon size={20} data-id="element-93" />} color="blue" data-id="element-92" />
        <StatCard title="Draft Newsletters" value={3} icon={<FileTextIcon size={20} data-id="element-95" />} color="yellow" data-id="element-94" />
        <StatCard title="Sent This Month" value={8} icon={<SendIcon size={20} data-id="element-97" />} color="green" change={{
        value: '25%',
        isPositive: true
      }} data-id="element-96" />
      </div>
      <div data-id="element-98">
        <RecentNewsletterCard newsletters={recentNewsletters} data-id="element-99" />
      </div>
    </div>;
};
export default Dashboard;